import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
const campaignsRpcClient = createRpcClientV2({
  hubHttpClient: http
});
export default campaignsRpcClient;